import React, { useContext } from "react";
import { InView } from "react-intersection-observer";
import ImageComponent from "../image/image.js";
import "./style.css";
import { groupContext } from "../index.js";
export default function CategoryImages(props) {
    var _a, _b;
    const group = useContext(groupContext);
    const imageLoader = (_b = (_a = group === null || group === void 0 ? void 0 : group.appearance) === null || _a === void 0 ? void 0 : _a.imageLoader) !== null && _b !== void 0 ? _b : "default-engine";
    return (React.createElement("div", { className: "category-images-container" }, props.images.map((image, index) => {
        return (React.createElement(InView, { triggerOnce: false, key: image.name, rootMargin: "100px" }, ({ inView, ref, entry }) => {
            var _a;
            return (React.createElement(ImageComponent, { inView: inView, groupId: group._id, imageLoader: imageLoader, entry: entry, galleryName: group === null || group === void 0 ? void 0 : group.galleryName, imageName: image.name, offers: props.offers, reference: ref, aspectRatio: (_a = image.aspectRatio) !== null && _a !== void 0 ? _a : undefined }));
        }));
    })));
}
